export const c_popover_MinWidth = {
  "name": "--pf-v6-c-popover--MinWidth",
  "value": "auto",
  "var": "var(--pf-v6-c-popover--MinWidth)"
};
export default c_popover_MinWidth;